export const obfuscateQuantity = function(quantity) {
  if (quantity === undefined || quantity === null || quantity <= 0) {
    return '—';
  }

  if (window._current_user && window._current_user.canViewTotalQuantity) {
    return quantity;
  }

  if (quantity < 10) {
    return quantity.toLocaleString();
  }

  if (quantity < 25) {
    return '>10';
  }

  return '>25';
};
